import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=56bcc84a&scoped=true&"
import script from "./VideoWrapper.vue?vue&type=script&lang=js&"
export * from "./VideoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcc84a",
  null
  
)

export default component.exports